module.exports = __webpack_public_path__ + "static/img/login.96769b8e.jpg";